// NG2
import { Component } from '@angular/core';

@Component({
  selector: 'novo-table-header',
  template: '<ng-content></ng-content>',
})
export class NovoTableHeaderElement {}
